// Autoplaza - entry. Detects current page via <body data-page> and runs the right init.
import { ready } from './lib/dom.js';
import { initNav } from './components/nav.js';
import { initPopovers } from './components/popover.js';
import { initAccountMenu } from './components/account-menu.js';
import { initModals } from './components/modal.js';
import { initDiaOfferModal } from './components/dia-offer-modal.js';
import { initShare } from './components/share.js';
import { initCardSliders } from './components/card-slider.js';
import { initFavorites } from './components/favorites.js';
import { initContactForms } from './components/contact-form.js';
import { initLeadCta } from './components/lead-cta.js';
import { initLeadValidation } from './components/lead-validate.js';
import { initCallPopover } from './components/call-popover.js';
import { initCallSwap } from './components/call-swap.js';
import { initRevealOnScroll } from './components/entrance-animations.js';
import { initStatCounters } from './components/counters.js';
import { initHeaderSearch } from './components/header-search.js';
import { initMultiselects } from './components/multiselect.js';
import { initInfoSidebar } from './components/info-sidebar.js';
import { initCookiesBanner } from './components/cookies.js';
import { initConfirmForms } from './components/saved-search.js';
import { initTabbar } from './components/tabbar.js';
import { initCollapsibleText } from './components/collapsible-text.js';
import { initIndexPage } from './pages/index.js';
import { initCatalogPage } from './pages/catalog.js';
import { initListingPage } from './pages/listing.js';
import { initAuthPage } from './pages/auth.js';
import { initEvaluarePage } from './pages/evaluare.js';
import { initTradeinPage } from './pages/tradein.js';
import { initCreditPage } from './pages/credit.js';
import { initLeasingPage } from './pages/leasing.js';
import { initAboutPage } from './pages/about.js';
import { initContactPage } from './pages/contact.js';
import { initStories } from './components/stories.js';
import { initClientMeta } from './components/client-meta.js';

ready(() => {
  // Always-on
  initClientMeta(); // attach screen/viewport/dpr/timezone to lead forms on submit
  initNav();
  initPopovers();
  initAccountMenu(); // desktop "Contul meu" hover/focus tab menu
  initModals();
  initShare();
  initCardSliders();
  initFavorites();
  initLeadValidation(); // name + phone checks on every lead form (document-level, no-op without one)
  initContactForms(); // safe no-op if no forms
  initLeadCta();      // safe no-op if no [data-component="lead-cta"] (listing CTA + offer modal)
  initCallPopover();  // desktop-only dealer phone/address popover on the car-page call buttons
  initCallSwap();     // swap dealer numbers by utm_source (client-side, cache-safe)
  initHeaderSearch();
  initMultiselects();
  initInfoSidebar();  // renders sidebar popular cars on info pages (no-op elsewhere)
  initCookiesBanner();
  initConfirmForms(); // data-confirm guard for account forms (saved-search delete)
  initTabbar();                // mobile bottom pill - shrinks on scroll down, grows on scroll up
  initCollapsibleText();       // editorial text: renders expanded, clamps after the first scroll

  // Page-specific (renders dynamic content like featured/catalog cards)
  switch (document.body.dataset.page) {
    case 'home': initIndexPage(); break;
    case 'catalog': initCatalogPage(); break;
    case 'listing': initListingPage(); break;
    case 'auth': initAuthPage(); break;
    case 'evaluare': initEvaluarePage(); break;
    case 'tradein': initTradeinPage(); break;
    case 'credit': initCreditPage(); break;
    case 'leasing': initLeasingPage(); break;
    case 'about': initAboutPage(); break;
    case 'contact': initContactPage(); break;
  }

  // Run AFTER page init so dynamically inserted elements (e.g. homepage
  // featured listings, catalog cards) are picked up by the observer.
  initRevealOnScroll();
  initStatCounters(); // count-up on the "De ce noi?" stats band, every page
  initStories();      // stories rail - self-guards; renders wherever the section exists (home + about)
  initDiaOfferModal(); // diaspora promo bands -> offer modal; self-guards elsewhere
});
